import { useState, useEffect } from 'react';
import { Grid, Button, Typography, TextField, CircularProgress, Tabs, Tab, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import { updateUserNameAPI } from 'api/CoreMlmmgmtWebServices';
import { setuserprofileInfo, setApiInProgress, refreshUserProfile } from 'store/slice/HeaderSlice';
import AddressDashboard from '../address/AddressDashboard';
import { getAddressInfoByPartneredAPI } from '../address/AddressAPI';
import { setAddressList, setMlmUserObj } from 'store/slice/EcomSlice';
import { getMlmuserInfoByUseridAPI } from 'components/mlmuser/MlmuserAPI';
import { setMlmuserEdituserModal } from 'store/slice/DmpSlice';
import EdituserActionModal from 'components/mlmuser/action/edituser/EdituserActionModal';
import { setMlmuserDashboardMlmuserList, setSelectedMlmuserId } from 'store/slice/DmpSlice';
import FieldView1 from '../layout/FieldView1';
import BankDetails from './BankDetails';

export default function ProfileMgmt() {
    const dispatch = useDispatch();
    const { userprofileInfo } = useSelector((state) => state.headerslice);
    const [editMode, setEditMode] = useState(false);
    const [name, setName] = useState(userprofileInfo.username);
    const [apiInProgress, setApiInProgress] = useState(false);
    const { mlmUserObj } = useSelector((state) => state.ecomslice.mlm);
    const { edituserModalOpen } = useSelector((state) => state.dmpslice.mlmuserDashboard);
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        getAddressInfoByPartneredAPI(userprofileInfo.userid, () => { }, getAddressListSuccess)
        //getMlmuserInfoByUseridAPI(userprofileInfo.userid, ()=>{}, getMlmUserSuccess);
        console.log("mlmUserObj=>"+JSON.stringify(mlmUserObj));
    }, [])

    useEffect(() => {
        if (!edituserModalOpen) getMlmuserInfoByUseridAPI(userprofileInfo.userid, () => { }, getMlmUserSuccess);
    }, [edituserModalOpen])

    const getMlmUserSuccess = (apiResponse) => {
        dispatch(setMlmuserDashboardMlmuserList(apiResponse))
        dispatch(setMlmUserObj(apiResponse[0]))
        dispatch(setSelectedMlmuserId(apiResponse[0].id))
    }
    const getAddressListSuccess = (apiResponse) => {
        dispatch(setAddressList(apiResponse));
    }
    const getAddressListFailure = () => {

    }


    const setNameValue = (e) => {
        const { name, value } = e.target;
        setName(value);
    }
    const saveNameSuccess = (apiResponse) => {
        setEditMode(false);
        setApiInProgress(false);
        setName(apiResponse.mlmuserInfo.title);
        dispatch(refreshUserProfile());
    }
    const saveNameFailure = (errMsg) => {
        setApiInProgress(false);
        setEditMode(false);
        console.log('!! ERROR !! =>' + errMsg);
    }
    const saveName = () => {
        setApiInProgress(true);
        updateUserNameAPI({
            "userName": name
        }, saveNameSuccess, saveNameFailure
        )
    }
    const editMlmUser = () => {
        dispatch(setMlmuserEdituserModal(true));
    }
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    const getAddress = () =>{
        return mlmUserObj.address+" "+mlmUserObj.city+" "+mlmUserObj.pincode;
    }

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tabIndex} onChange={handleTabChange} aria-label="Profile Tabs">
                    <Tab label="Profile" />
                    <Tab label="Address" />
                    <Tab label="Bank Details" />
                </Tabs>
            </Box>
            {tabIndex === 0 && mlmUserObj && (
                <Grid container direction="column">
                    <Grid item lg={12} xs={12} sx={{ padding: 1, borderRadius: 2 }}>
                        <Grid container direction="row" justifyContent="space-between" alignItems="right">
                            <Grid item lg={11} xs={11} sx={{ padding: .5 }}>
                                <Typography variant="h4" color="primary.darker">Your Profile</Typography>
                            </Grid>
                            <Grid item justifyContent="flex-end" lg={1} xs={1} sx={{ padding: .5, alignItems: 'right', display: 'flex' }}>
                                <EditIcon
                                    sx={{ cursor: 'pointer', color: 'primary.darker' }}
                                    onClick={() => editMlmUser()}
                                />
                            </Grid>
                            <Grid item lg={12} xs={12} sx={{ width: '100%', backgroundColor: 'white', borderRadius: 2 }} >
                                <Grid container direction="row" justifyContent="space-between" >
                                    <Grid item lg={4} xs={12}>
                                        <FieldView1
                                            label="Name"
                                            value={name.split('@')[0]}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={6}>
                                        <FieldView1
                                            label="PAN"
                                            value={mlmUserObj.pan}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={6}>
                                        <FieldView1
                                            label="Adhar"
                                            value={mlmUserObj.aadharnumber}
                                        />
                                    </Grid>
                                    <Grid item lg={12} xs={12}>
                                        <FieldView1
                                            label="Address"
                                            value={getAddress()}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={12} xs={12} sx={{ height: '300px' }}>
                        &nbsp;
                    </Grid>
                </Grid>
            )}
            {tabIndex === 1 && (
                <Grid item lg={12} xs={12} sx={{ padding: .5 }}>
                    <AddressDashboard />
                </Grid>
            )}
            {tabIndex === 2 && (
                <Grid item lg={12} xs={12} sx={{ padding: .5 }}>
                    <BankDetails />
                </Grid>
            )}
            <EdituserActionModal />
        </>
    );
}